import React, { createContext, useContext, useState, useCallback, useMemo } from "react";
import TWI from "./strings";

const LanguageContext = createContext({ lang: "en", setLang: () => {}, t: (s) => s });

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem("okuapem_lang") || "en");
  const setLang = useCallback((l) => { localStorage.setItem("okuapem_lang", l); setLangState(l); }, []);
  const t = useCallback((s) => (lang === "tw" && TWI[s]) || s, [lang]);
  const value = useMemo(() => ({ lang, setLang, t }), [lang, setLang, t]);
  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export const useLang = () => useContext(LanguageContext);
